import React, { useState } from "react";

const EmploymentGapsInput = ({
  data,
  index,
  handleReason,
  hasError = false,
  gapName,
}) => {
  const handleOnChange = (e) => {
    e.preventDefault();
    handleReason(e.target.value, index);
  };
  return (
    <div class="row mb-2">
      <div class="col-12">
        <div class="common-box-gray p-2 mb-2">
          <h6 class="fnt-smi-bld">
            {index + 1}. {gapName} Gap
          </h6>
          <span class="task-status orange">
            <i class="far fa-calendar orange-icon mr-2"></i>
            {data.tenure_from} - {data.tenure_to}
          </span>
          <p class="text-muted fnt-sml-md mt-1">
            There is a significant gap between your {data.label}.
          </p>
          <div class="form-group mb-0">
            <input
              type="text"
              class="form-control"
              placeholder="Enter Reason"
              value={data.gap_reason}
              onChange={(e) => handleOnChange(e)}
            />
          </div>
          {hasError == true ? (
            data.gap_reason == "" || data.gap_reason == null ? (
              <p className="err text-danger">This field is required</p>
            ) : (
              <p className="err text-danger">Please provide valid input</p>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmploymentGapsInput;
